import { NS } from "../common/classes";

export const SCROLLABLE_DIV = `${NS}-scrollable-div`;
export const SCROLLABLE_DIV_CONTAINER = `${SCROLLABLE_DIV}-container`;
export const SCROLLABLE_DIV_INNER_CONTAINER = `${SCROLLABLE_DIV}-inner-container`;
